import ProductItem from 'sevenOfferPageNodeTypes/ProductItem';

export {
    ProductItem,
};
